import script from "./Scheduler.vue?vue&type=script&setup=true&lang=js"
export * from "./Scheduler.vue?vue&type=script&setup=true&lang=js"

import "./Scheduler.vue?vue&type=style&index=0&id=5b0581ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b0581ce"]])

export default __exports__